import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { GetReportByEmailPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction(async (payload: GetReportByEmailPayload) =>
    $actions.document.getReportByEmail(dispatch, payload),
  );
};
